﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_dialogRouter2Button from './tpl/dialogRouter2Button.html';

export default Marionette.ItemView.extend({
    dialogRouterRegion: '#dialogRouter2Button_modal',
    getTemplate: function () {
        return tpl_dialogRouter2Button({ model: this.model.toJSON() });
    },
    events: {
        "click #dialogRouter2Button_btn01": "onBtn01",
        "click #dialogRouter2Button_btn02": "onBtn02"
    },
    onBtn01: function () {
        this.triggerMethod('dialogRouter:btn01clicked', "msg");
        this.trigger("dialog:close");
    },
    onBtn02: function () {
        this.triggerMethod('dialogRouter:btn02clicked', "msg");
        this.trigger("dialog:close");
    }
});